import React from 'react'

const CollapsedLogo = () => {
    return (
        <h2 className="collapsedSNISTLogo">SNIST</h2>
    )
}

export default CollapsedLogo
